<template>
  <div>
    <b-row class="mb-4">
      <b-col>
        <fcc-select v-model="fase" :options="listaFases" :clearable="false">
          Fase
        </fcc-select></b-col
      >
      <b-col>
        <fcc-select
          v-model="campo"
          :options="listaCampos"
          labelField="campo"
          valueField="idcampo"
          :clearable="false"
        >
          Campo
        </fcc-select>
      </b-col>
      <b-col v-if="campo">
        <fcc-input v-if="tipoValor === 0" v-model="valorTexto" :disabled="!campo">Valor</fcc-input>
        <fcc-select
          v-model="valorSelect"
          labelField="valor"
          valueField="idvalor"
          :options="listaValor"
          :disabled="!campo"
          :clearable="false"
          v-else
        >
          Valor
        </fcc-select>
      </b-col>
    </b-row>

    <b-row align-h="end">
      <b-col class="mb-3 text-right">
        <fcc-button @click="obterInfoCandidatosImportPorMetadado" :disabled="buscarDesabilitado"
          >Buscar</fcc-button
        >
      </b-col>
    </b-row>

    <b-row v-if="items.length > 0">
      <b-col>
        <fcc-table
          striped
          hover
          pdf
          xls
          csv
          responsive
          search
          pagination
          field-visibility
          :titlePage="titlePage"
          :titlePDF="titlePage"
          :fields="fields"
          :items="items"
          :porPage="itemPorPage"
          :key="keyTable"
          @row-selected="selecionaItems"
        />
      </b-col>
    </b-row>

    <b-row align-h="end" v-if="items.length > 0">
      <b-col class="mb-3 text-right">
        <fcc-button :disabled="dadosSelecionados.length <= 0" @click="importar"
          >Importar</fcc-button
        >
      </b-col>
    </b-row>

    <fcc-logs-importacao
      :base-url-publicacao="baseUrlPublicacao"
      :idoutfase="idoutfase"
      :controle-page="controlePage"
      :tp-importacao="tpImportacao"
      :logs="logs"
      @excluir="excluirInfoImportacaoMetadado"
    />
  </div>
</template>
<script>
import axios from 'axios'
import FccLogsImportacao from './fccLogsImportacao.vue'
import fccGravarLog from './fccGravarLog.vue'

export default {
  mixins: [fccGravarLog],
  props: {
    baseUrlPublicacao: String,
    idoutfase: Number,
    controlePage: Object,
    tpImportacao: Number,
    listaFases: Array
  },
  data() {
    return {
      titlePage: 'Importação de Candidatos - Metadados',
      fase: '',
      campo: '',
      listaCampos: [],
      valorTexto: '',
      valorSelect: '',
      listaValor: [],
      tipoValor: 0,
      items: [],
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: true
        },
        { key: 'idpublicacao', label: 'Publicação', sortable: true },
        { key: 'idoutfase', label: 'Outras Fases', sortable: true },
        { key: 'idfase', label: 'Fase', sortable: true },
        { key: 'codcargo', label: 'Código Cargo', sortable: true },
        { key: 'campo', label: 'Campo', sortable: true },
        { key: 'ninscricoes', label: 'N° Inscrições', sortable: true, totalizar: true },
        { key: 'importados', label: 'N° Importados', sortable: true, totalizar: true }
      ],
      itemPorPage: '10',
      keyTable: 0,
      dadosSelecionados: [],
      logs: []
    }
  },
  components: {
    FccLogsImportacao
  },
  created() {
    this.obterCamposImportacaoPorMetadado()
    this.listarLogs()
  },
  computed: {
    buscarDesabilitado() {
      return (
        !this.fase ||
        !this.campo ||
        (this.tipoValor && !this.valorSelect) ||
        (!this.tipoValor && !this.valorTexto)
      )
    },
    idValor() {
      return this.tipoValor ? this.valorSelect : 0
    },
    valor() {
      return this.tipoValor ? '' : this.valorTexto
    }
  },
  watch: {
    campo(value) {
      if (value) {
        this.tipoValor = this.listaCampos.find((item) => item.idcampo === value).campocategorico
        this.valorTexto = ''
        this.valorSelect = null
        if (this.tipoValor) {
          this.obterValoresImportacaoPorMetadado()
        }
      }
    }
  },
  methods: {
    obterCamposImportacaoPorMetadado() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterCamposImportacaoPorMetadado',
          {
            idPublicacao: this.controlePage.idpublicacao
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.listaCampos = data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    obterValoresImportacaoPorMetadado() {
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterValoresImportacaoPorMetadado',
          {
            idPublicacao: this.controlePage.idpublicacao,
            idCampo: this.campo
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.listaValor = data
        })
        .catch(this.setErrorSystem)
    },
    obterInfoCandidatosImportPorMetadado() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterInfoCandidatosImportPorMetadado',
          {
            idPublicacao: this.controlePage.idpublicacao,
            idOutraFase: this.idoutfase,
            idFase: this.fase,
            idCampo: this.campo,
            idValor: this.idValor,
            valor: this.valor
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          if (data.length === 0) {
            this.callAlert('A busca não retornou resultados.', '', 'error', 'error')
          }
          this.items = data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    importar() {
      const body = this.dadosSelecionados.map((item) => {
        return {
          idPublicacao: this.controlePage.idpublicacao,
          idOutraFase: this.idoutfase,
          idFase: this.fase,
          idCampo: this.campo,
          idValor: this.idValor,
          valor: this.valor,
          tpImportacaoOutrasFases: this.tpImportacao,
          codCargo: item.codcargo,
          cd_Funcionario: this.dadosUserSession.usuCdFuncionario
        }
      })

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ImportarCandidatosPorMetadado',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast('Importado com sucesso.', 'success')
          this.keyTable = this.keyTable + 1
          this.gravarLogImportacaoCandidatosOutrasFases()
          this.obterInfoCandidatosImportPorMetadado()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarLogs() {
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterInfoImportacaoPorMetadado',
          {
            id_Publicacao: this.controlePage.idpublicacao,
            id_OutraFase: this.idoutfase
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.logs = data
        })
        .catch(this.setErrorSystem)
    },
    excluirInfoImportacaoMetadado() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ExcluirInfoImportacaoMetadado',
          {
            id_Publicacao: this.controlePage.idpublicacao,
            id_OutraFase: this.idoutfase,
            cd_Funcionario: this.dadosUserSession.usuCdFuncionario
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.excluido, 'success')
          this.listarLogs()
          if (!this.buscarDesabilitado && this.items.length > 0)
            this.obterInfoCandidatosImportPorMetadado()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    selecionaItems(value) {
      this.dadosSelecionados = value
    }
  }
}
</script>